import AuthService from '..';
import { account, adminAccount } from '../../login/impl/account';
import { mobile } from '../../login/impl/mobile';

export const basic = new AuthService({
  forceLoginProps: {
    url: '/api/user/v1/user/authLoginOtherByToken',
    fields: {
      username: 'loginName',
      token: 'loginToken',
    }
  },
  logoutProps: {
    url: '/api/user/v1/user/authLoginOut',
  },
  AccountService: account,
  MobileService: mobile,
  alias: 'userInfo',
  formatter: e => e,
});
account.parent = basic;
mobile.parent = basic;

export const admin = new AuthService({
  logoutProps: {
    url: '/api/user/v1/admin/authLoginOut',
  },
  AccountService: adminAccount,
  alias: 'adminInfo',
  formatter: ({ adminId, adminName, adminPhone, adminType, adminStatus, registerTime, lastLoginIp, lastLoginTime }) => ({
    id: adminId,
    userName: adminName,
    userPhone: adminPhone,
    userType: adminType,
    userStatus: adminStatus,
    registerTime,
    lastLoginIp,
    lastLoginTime,
  }),
});
adminAccount.parent = admin;